import React, { useState, useEffect } from 'react'
import { ToggleButton } from 'react-bootstrap'
import DayPicker from 'react-day-picker'
import MomentLocaleUtils from 'react-day-picker/moment'
import 'moment/locale/nl'
import 'react-day-picker/lib/style.css'
import DateInput from './DateInput'
import { formatDate } from '../service/helpers/DateUtilities'

interface IProps {
  disabled?: boolean
  date: Date
  onDateChanged: (date: Date) => void
  showMaxDate?: boolean
  maxEndDate: Date
  name: string
}

export default (props: IProps) => {
  const [date, setDate] = useState(new Date())

  useEffect(() => {
    setDate(props.date)
  }, [props.date])

  const dateChanged = (changed: Date) => {
    setDate(changed)
    props.onDateChanged(changed)
  }

  const isMaxDate = (): boolean => {
    return formatDate(date) === formatDate(props.maxEndDate)
  }

  const setMaximumEndDate = (checked: boolean) => {
    if (checked) {
      dateChanged(props.maxEndDate)
    } else {
      dateChanged(new Date())
    }
  }

  return (
    <React.Fragment>
      <div>
        <DateInput
          disabled={props.disabled}
          date={date}
          onDateChanged={dateChanged}
        />
      </div>
      <div>
        {!props.disabled && (
          <DayPicker
            fromMonth={new Date()}
            toMonth={props.maxEndDate}
            month={date}
            initialMonth={date}
            selectedDays={date}
            todayButton='Vandaag'
            onDayClick={dateChanged}
            localeUtils={MomentLocaleUtils}
            locale={'nl'}
          />
        )}
        {props.disabled && (
          <p className='wrap p-2'>
            Deze {props.name} kan niet meer gewijzigd worden.
          </p>
        )}
      </div>
      {props.showMaxDate && (
        <div>
          <ToggleButton
            type='checkbox'
            variant='primary'
            checked={isMaxDate()}
            value='1'
            onChange={e => setMaximumEndDate(e.currentTarget.checked)}
          >
            Max Einddatum
          </ToggleButton>
        </div>
      )}
    </React.Fragment>
  )
}
